var React = require('react');

function EmailIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M336.8,45.9H45.4C20.3,45.9,0,65.5,0,89.5v203.1c0,24,20.3,43.6,45.4,43.6h291.4c25,0,45.4-19.5,45.4-43.6V89.5\n\tC382.1,65.5,361.8,45.9,336.8,45.9z M336.8,297.7H45.4c-3.7,0-6.9-2.4-6.9-5.1V116.4l131.8,111.3c2.7,2.3,6.1,3.5,9.7,3.5l22.3,0\n\tc3.5,0,7-1.3,9.7-3.5l131.8-111.3v176.3C343.7,295.3,340.4,297.7,336.8,297.7z M191.1,193L62.9,84.4h256.4L191.1,193z"}));
}

EmailIcon.defaultProps = {"version":"1.1","id":"Capa_1","x":"0px","y":"0px","viewBox":"0 0 382.1 382.1","style":{"enableBackground":"new 0 0 382.1 382.1"},"xmlSpace":"preserve"};

module.exports = EmailIcon;

EmailIcon.default = EmailIcon;
